import {
  EXCEL_DATA_RESET,
  EXCEL_SET_DATA,
  EXCEL_SET_ITEMS,
  EXCEL_SET_TAB,
} from "../../constants/excelConstants";

const initialState = {
  excelData: undefined,
  saveItems: null,
  activeTab: null,
};

const excelReducer = (state = initialState, action) => {
  switch (action.type) {
    case EXCEL_DATA_RESET:
      return {
        ...state,
        excelData: undefined,
        savedItems: null,
        activeTab: null,
      };
    case EXCEL_SET_DATA:
      return {
        ...state,
        excelData: action.excelData,
      };
    case EXCEL_SET_TAB:
      return {
        ...state,
        activeTab: action.activeTab,
      };
    case EXCEL_SET_ITEMS:
      return {
        ...state,
        savedItems: action.savedItems,
      };
    default:
      return state;
  }
};

export default excelReducer;
